import React, { useState } from "react";
import loadable from "@loadable/component"
const HistoryComponent=loadable(
  ()=>import("../../components/History/History")
)

const History = () => {
  return (
    <>
      <HistoryComponent/>
    </>
  );
};

export default History;
